<template>
  <b-sidebar
    right
    shadow
    backdrop
    v-model="showSidebar"
    width="50%"
    @change="visibleChanged"
    no-header
    prop
  >
    <div class="pd-20">
      <Form
        :model="postModel"
        label-width="220px"
        v-if="modelReady"
        size="small"
      >
        <!-- v-if="$store.state.user.userInfo.groupId == 1105" -->
        <FormItem label="Үндсэн үйл ажиллагааны чиглэл">
          <!-- disableAdd -->
          <loc-type-cascader
            :id="postModel.locTypeId1"
            v-model="postModel.locTypeId1"
            :getParentType="true"
            locTypekey="planRptMain"
          />
        </FormItem>
        <FormItem
          :label="
            $store.state.user.userInfo.groupId == 1105
              ? 'Стратеги төлөвлөгөөний зорилт'
              : 'Төрөл'
          "
        >
          <loc-type-cascader
            :id="postModel.locTypeId"
            v-model="postModel.locTypeId"
            :getParentType="true"
            locTypekey="planRptKeys"
          />
          <!-- disableAdd -->
        </FormItem>
        <FormItem label="Ажил хэрэг">
          <Input
            v-model="postModel.projectName"
            placeholder="Нэрээ оруулна уу"
          ></Input>
        </FormItem>
        <FormItem label="Тайлбар">
          <Input
            v-model="postModel.projectDesc"
            placeholder="Тайлбар бичнэ үү"
          ></Input>
        </FormItem>
        <FormItem label="Үндсэн харагдац">
          <Select v-model="postModel.defaultView">
            <Option :value="0" label="Жагсаалт">Жагсаалт</Option>
            <Option :value="1" label="Канбан">Канбан</Option>
          </Select>
        </FormItem>
        <FormItem label="Эхлэх/Дуусах">
          <Row>
            <Col :span="11">
              <DatePicker
                type="datetime"
                placeholder="Эхлэх"
                v-model="postModel.startDate"
                @on-change="
                  (value) =>
                    (postModel.dueStartDate = value.toLocaleString() + '')
                "
              ></DatePicker>
            </Col>
            <Col :span="2" style="text-align: center">-</Col>
            <Col :span="11">
              <DatePicker
                type="datetime"
                placeholder="Дуусах"
                v-model="postModel.endDate"
                @on-change="
                  (value) =>
                    (postModel.dueStartDate = value.toLocaleString() + '')
                "
              ></DatePicker>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="Ажил хэрэг солих">
          <RadioGroup v-model="postModel.isChildShare">
            <Radio :value="true" :label="true">Тийм</Radio>
            <Radio :value="false" :label="false">Үгүй</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="Төлөвлөгөө болгох">
          <RadioGroup v-model="postModel.isPlan" :disabled="isPlanLocked">
            <Radio :value="true" :label="true">Тийм</Radio>
            <Radio :value="false" :label="false">Үгүй</Radio>
          </RadioGroup>
          <!-- <i-switch
          v-model=""
          size="large"
          
        >
          <span slot="open">Yes</span>
          <span slot="close">No</span>
        </i-switch> -->
        </FormItem>
        <FormItem
          label="Байгууллагын төлөвлөгөөнд оруулах"
          v-if="postModel.isPlan != undefined && postModel.isPlan"
        >
          <RadioGroup v-model="postModel.isOrgPlan">
            <Radio :value="true" :label="true">Тийм</Radio>
            <Radio :value="false" :label="false">Үгүй</Radio>
          </RadioGroup>
          <!-- <i-switch v-model="" size="large">
          <span slot="open">Yes</span>
          <span slot="close">No</span>
        </i-switch> -->
        </FormItem>

        <template v-if="postModel.groupId == 98">
          <FormItem label="Дэвсгэр өнгө"> </FormItem>
          <FormItem label="Загвар эсэх">
            <RadioGroup v-model="postModel.isTemplate">
              <Radio :value="true" label="Тийм"></Radio>
              <Radio :value="false" label="Үгүй"></Radio>
            </RadioGroup>
            <!-- <i-switch v-model="" size="large">
            <span slot="open">Yes</span>
            <span slot="close">No</span>
          </i-switch> -->
          </FormItem>
        </template>

        <FormItem>
          <Button @click="createProject()" type="primary">Хадгалах</Button>
          <Button @click="visibleChanged(false)" style="margin-left: 8px"
            >Болих</Button
          >
        </FormItem>
      </Form>
    </div>
  </b-sidebar>
</template>

<script>
import { request } from "@/api/all";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  FormItem,
  Button,
  Select,
  Option,
  Input,
  Row,
  Col,
  DatePicker,
  RadioGroup,
  Radio,
} from "element-ui";
export default {
  components: {
    Form,
    FormItem,
    Select,
    Button,
    Option,
    Input,
    Row,
    Col,
    DatePicker,
    RadioGroup,
    Radio,
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    isShow: {
      type: Boolean,
      default: () => false,
    },
    id: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      showSidebar: false,
      modelReady: false,
      postModel: {
        projectName: "",
        groupId: 0,
        // title: '',
        // desc: '',
        // viewmode: 0,
        // start: '',
        // end: '',
        // qpoint: false,
        // column: false,
        // isPlan:0,
      },
    };
  },
  mounted() {
    //console.log("project edit mounbted");
  },
  methods: {
    getInherited() {
      request({
        api: { method: "get", url: "Project/GetInheritedProject" },
        params: {
          id: this.id,
        },
        store: this.$store,
      }).then((res) => {
        this.postModel = res.data.project;
        this.modelReady = true;
      });
    },
    init() {
      if (this.id != null && this.id > 0) {
        request({
          api: { method: "get", url: "Project/PreEdit" },
          params: {
            id: this.id,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.getInherited();
          } else {
            this.visibleChanged(false);
          }
        });
      } else {
        this.getInherited();
      }
    },
    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-close");
      }
    },
    createProject() {
      if (
        this.postModel.projectName != null &&
        this.postModel.projectName.length > 0
      ) {
        request({
          api: { method: "post", url: "Project/PostInheritedProject" },
          data: {
            model: this.postModel,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.modelReady = false;
            this.projectDrawer = false;
            this.$emit("on-updated");
            this.visibleChanged(false);
            this.$bvToast.toast("Амжилттай хадгаллаа", {
              title: "Мэдэгдэл",
              autoHideDelay: 5000,
              appendToast: false,
              variant: "success",
              toaster: "b-toaster-bottom-left",
            });
          }
        });
      } else {
        this.$bvToast.toast("Ажил хэргийн нэр заавал бичих шаардлагатай", {
          title: "Мэдэгдэл",
          autoHideDelay: 5000,
          appendToast: false,
          variant: "warning",
          toaster: "b-toaster-bottom-left",
        });
      }
    },
  },
  watch: {
    isShow(newVal) {
      if (newVal) {
        //console.log("nee")
        this.passModel = this.json;
        this.showSidebar = true;
        this.init();
      }
    },
  },
};
</script>